import { render } from "./PostListCommentItem.vue?vue&type=template&id=56185a08"
import script from "./PostListCommentItem.vue?vue&type=script&lang=js"
export * from "./PostListCommentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__